import {
    EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
    PLATFORM_ID,
    provideAppInitializer,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WINDOW } from '@seven1/angular/ssr';

export const SCROLL_TO_POS = 'SCROLL_TO_POS';

interface ScrollToPosMessage {
    type: typeof SCROLL_TO_POS;
    x?: number;
    y?: number;
}

function isScrollToPosMessage(data: unknown): data is ScrollToPosMessage {
    return (
        !!data &&
        typeof data === 'object' &&
        (data as { type?: unknown }).type === SCROLL_TO_POS
    );
}

export function handleScrollMessage(event: MessageEvent, targetWindow: Window): void {
    if (!isScrollToPosMessage(event.data)) return;
    targetWindow.scrollTo({ left: event.data.x ?? 0, top: event.data.y ?? 0, behavior: 'smooth' });
}

export function scrollBridgeInitializer(): void {
    const platformId = inject(PLATFORM_ID);
    if (!isPlatformBrowser(platformId)) return;

    const targetWindow = inject(WINDOW);
    if (!targetWindow) return;

    targetWindow.addEventListener('message', (event) => handleScrollMessage(event, targetWindow));
}

export function provideIframeScrollBridge(): EnvironmentProviders {
    return makeEnvironmentProviders([provideAppInitializer(scrollBridgeInitializer)]);
}
